import { DetailedHTMLProps, TextareaHTMLAttributes } from "react";

import styles from "./TextAreaInput.module.scss";

export type TextAreaInputProps = {
  placeholder: string;
  label?: string;
  description?: string;
  inputValue?: string;
  setInputValue?: (value: string) => void;
  onSubmit?: () => void;
  disabled?: boolean;
  dataTest?: string;
  className?: string;
  inputProps?: DetailedHTMLProps<
    TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  >;
};

export const TextAreaInput = ({
  placeholder,
  label,
  description,
  inputValue,
  setInputValue,
  onSubmit,
  disabled,
  dataTest,
  className,
  inputProps,
}: TextAreaInputProps): JSX.Element => {
  return (
    <div className={`${styles.text_area_wrapper} ${className ?? ""}`}>
      {label && (
        <div className={styles.field_caption}>
          <span className={styles.field_name}>{label}</span>
        </div>
      )}
      <div
        className={`${styles.text_area_input_container} ${
          disabled ? styles.disabled : ""
        }`}
      >
        <textarea
          className={styles.text_area_input}
          value={inputValue}
          rows={4}
          data-test={dataTest}
          onChange={(e) => setInputValue?.(e.target.value)}
          placeholder={placeholder}
          onKeyDown={(e) => {
            if (e.key === "Enter" && onSubmit) {
              onSubmit();
            }
          }}
          {...inputProps}
        />
      </div>
      {description && (
        <span className={styles.field_description}>{description}</span>
      )}
    </div>
  );
};
